import React from 'react';
import { Badge, Button, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { getStoredAuth } from '../api/client';
import PortalPageShell from './PortalPageShell';

export default function AdminDashboard() {
  const { user } = getStoredAuth();

  return (
    <PortalPageShell
      title="Admin Dashboard"
      subtitle="Manage portal content in one place."
    >
      <Stack spacing={6}>
        <Stack p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" spacing={3} bg="gray.50">
          <Heading size="sm">Admin Details</Heading>
          <Text><strong>Email:</strong> {user?.email || 'Not available'}</Text>
          <Text>
            <strong>Role:</strong>{' '}
            <Badge colorScheme="purple">{user?.role || 'admin'}</Badge>
          </Text>
        </Stack>

        <Heading size="md">Quick Actions</Heading>
        <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={5}>
          <Stack p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" spacing={3}>
            <Heading size="sm">Subscriptions</Heading>
            <Text color="gray.600">Create, edit, and enable or disable pricing plans.</Text>
            <Button as={RouterLink} to="/admin/plans" colorScheme="cyan" width="fit-content">
              Open Plans
            </Button>
          </Stack>
          <Stack p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" spacing={3}>
            <Heading size="sm">Subscribers</Heading>
            <Text color="gray.600">Review subscriber accounts and enable or disable portal access.</Text>
            <Button as={RouterLink} to="/admin/subscribers" colorScheme="teal" width="fit-content">
              Open Subscribers
            </Button>
          </Stack>
          <Stack p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" spacing={3}>
            <Heading size="sm">Manage Articles</Heading>
            <Text color="gray.600">Review published content and keep the member area updated.</Text>
            <Button as={RouterLink} to="/admin/articles" colorScheme="blue" width="fit-content">
              Open Articles
            </Button>
          </Stack>
          <Stack p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" spacing={3}>
            <Heading size="sm">Create New Article</Heading>
            <Text color="gray.600">Add text articles or PDF resources for members.</Text>
            <Button as={RouterLink} to="/admin/articles/new" colorScheme="purple" width="fit-content">
              Create Article
            </Button>
          </Stack>
        </SimpleGrid>
      </Stack>
    </PortalPageShell>
  );
}
